// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__J8SSE","label":"Labeled_label__22FAI","divider":"Labeled_divider__280GF"};